import WorkerShiftContainer from "./WorkerShift.container";

export default WorkerShiftContainer;
